import GridOutline from "@/components/GridOutline";
import CoverImage, { CoverImageProps } from "./CoverImage";
import BackButton from "@/components/BackButton";
import Aside from "./Aside";
import Article from "./Article";
import { Container, Content, ButtonsContainer } from "./styles";
import NextButton from "./NextButton";
import PrevButton from "./PrevButton";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

export type ArticleProps = {
  heading: string;
  coverImage: CoverImageProps;
  category: string | null;
  releaseDate: string;
  body: Record<string, any>[];
  prevSlug: string | null;
  nextSlug: string | null;
};

const NewsArticle: React.FC<ArticleProps> = (props) => {
  const { coverImage, heading, category, releaseDate, body, prevSlug, nextSlug } = props;
  const { locale = "it" } = useRouter();
  const label = useTranslation("page.goBack", locale);
  return (
    <Container>
      <BackButton href={`/${locale}/news`}>{label}</BackButton>
      <CoverImage asset={coverImage.asset} />
      <Content>
        <Aside releaseDate={releaseDate} category={category} />
        <Article heading={heading} body={body}>
          <ButtonsContainer>
            {prevSlug && <PrevButton slug={prevSlug} />}
            {nextSlug && <NextButton slug={nextSlug} />}
          </ButtonsContainer>
        </Article>
      </Content>
      <GridOutline />
    </Container>
  );
};

export default NewsArticle;
